// extracted by mini-css-extract-plugin
export var container = "AddFavourite-module--container--bc0e4";
export var dogcardimage = "AddFavourite-module--dogcardimage--747cc";
export var iconwrapper = "AddFavourite-module--iconwrapper--872d3";
export var login = "AddFavourite-module--login--36cec";
export var loginlink = "AddFavourite-module--loginlink--0b311";
export var title = "AddFavourite-module--title--154c0";